import {
  ClassificationLevel,
  ProcedureReportStatus,
  ProcedureReportStatusCardKey,
} from './procedure-report-types';

export type ProcedureReportStatusConfig = {
  id: ProcedureReportStatus;
  color: string;
  icon: string;
  labelKey: string;
  cardKey: ProcedureReportStatusCardKey;
  dashboardLabelKey: string;
  classificationKey: 'classified' | 'nonClassified' | 'pendingApproval';
};

export const procedureReportStatusConfig: ProcedureReportStatusConfig[] = [
  {
    id: 'CLASSIFICADO',
    color: '#4BC96A',
    icon: 'mdi-check-circle-outline',
    labelKey: 'procedureReport.filter.status.classified',
    cardKey: 'classified',
    dashboardLabelKey: 'procedureReport.dashboard.classifiedDescription',
    classificationKey: 'classified',
  },
  {
    id: 'NAO_CLASSIFICADO',
    color: '#FF0909',
    icon: 'mdi-close-circle-outline',
    labelKey: 'procedureReport.filter.status.unclassified',
    cardKey: 'unclassified',
    dashboardLabelKey: 'procedureReport.dashboard.nonClassifiedDescription',
    classificationKey: 'nonClassified',
  },
  {
    id: 'PENDENTE_APROVACAO',
    color: '#F5A623',
    icon: 'mdi-clock-outline',
    labelKey: 'procedureReport.filter.status.pendingApproval',
    cardKey: 'pendingApproval',
    dashboardLabelKey: 'procedureReport.dashboard.pendingApprovalDescription',
    classificationKey: 'pendingApproval',
  },
];

export const getStatusConfig = (status: string | null | undefined) => (
  procedureReportStatusConfig.find((config) => config.id === status)
);

export const getDefaultStatusConfig = () => (
  procedureReportStatusConfig.find((config) => config.id === 'NAO_CLASSIFICADO')
  ?? procedureReportStatusConfig[1]
);

export const getStatusConfigByCardKey = (cardKey: ProcedureReportStatusCardKey) => (
  procedureReportStatusConfig.find((config) => config.cardKey === cardKey)
);

export const isPendingApprovalProcedure = (
  item: { status?: string | null; isNew?: boolean } | null | undefined,
): boolean => {
  if (!item) return false;
  return !item.isNew && item.status === 'PENDENTE_APROVACAO';
};

export const classificationLevelOptions: { id: ClassificationLevel; nameKey: string }[] = [
  { id: 'EVENT', nameKey: 'procedureReport.levels.event' },
  { id: 'COMPLEMENT', nameKey: 'procedureReport.levels.complement' },
  { id: 'GROUP', nameKey: 'procedureReport.levels.group' },
  { id: 'SUBGROUP', nameKey: 'procedureReport.levels.subgroup' },
  { id: 'PREDICTIVE', nameKey: 'procedureReport.levels.predictive' },
  { id: 'PREDICTIVE_CLASSIFICATION', nameKey: 'procedureReport.levels.predictiveClassification' },
];
